import React, { useState, useEffect } from "react";
import withReduxProvider from "web/react/redux-provider";
import { connect, useDispatch } from "react-redux";
import { gettext } from "web/script/modules/django-i18n";
import Switch from "web/react/components/switch/switch";
import SvgIcon from "web/react/components/svg-icon/svg-icon";
import { consentToAllCookies, rejectAllNonEssentialCookies } from "web/redux/ducks/cookie-consent";
import styles from "./ccpa-option.css";

function mapStateToProps(state): object {
    const { acceptsCustomization, acceptsAds, acceptsAnalytics } = state.cookieConsentReducer;
    return {
        acceptsCustomization,
        acceptsAds,
        acceptsAnalytics,
    };
}

interface CcpaOptionProps {
    acceptsCustomization: boolean;
    acceptsAds: boolean;
    acceptsAnalytics: boolean;
}

function CcpaOption({
    acceptsCustomization,
    acceptsAds,
    acceptsAnalytics,
}: CcpaOptionProps): JSX.Element {
    const dispatch = useDispatch();

    const [optOut, setOptOut] = useState(false);
    const [updated, setUpdated] = useState(false);

    useEffect(() => {
        const optOutState = !(acceptsCustomization || acceptsAds || acceptsAnalytics);
        setOptOut(optOutState);
    }, [acceptsCustomization, acceptsAds, acceptsAnalytics]);

    function toggleOptOption(optOut): void {
        setOptOut(optOut);
        setUpdated(!updated);
        if (optOut) {
            dispatch(rejectAllNonEssentialCookies());
        } else {
            dispatch(consentToAllCookies());
        }
    }

    function getOptInOptionIcon(): JSX.Element {
        return <SvgIcon name={updated ? "tick" : "info-icon"} />;
    }

    function getOptInOptionText(): string {
        return optOut
            ? gettext("privacy_policy.california_privacy_rights.opted_out.label")
            : gettext("privacy_policy.california_privacy_rights.opted_in.label");
    }

    return (
        <div className={styles.optOutWidgetContainer}>
            <div className={styles.optOutWidget}>
                <p>{gettext("privacy_policy.california_privacy_rights.opt_out.title")}</p>
                <div className={styles.optOutSelector}>
                    <p>{gettext("privacy_policy.california_privacy_rights.do_not_sell.label")}</p>
                    <Switch selected={optOut} disabled={false} onChange={toggleOptOption} />
                </div>
            </div>
            <div className={styles.ccpaOptSelectedOption}>
                <span>
                    {getOptInOptionIcon()}
                    {gettext(getOptInOptionText())}
                </span>
            </div>
            <div className={styles.ccpaAdditionalInfo}>
                {gettext("privacy_policy.california_privacy_rights.change_preferences.label")}
            </div>
        </div>
    );
}

export default withReduxProvider(connect(mapStateToProps)(CcpaOption));
